//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { requestRedirectionWorkAreas } from './RequestRedirectionWorkAreas.js'

export default {
  name: 'RequestRedirectedWorkAreaField',
  mixins: [requestRedirectionWorkAreas],
  props: {
    request: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workAreas: null // []
    }
  },
  watch: {
    'request.serviceObject': {
      handler: function (serviceObject) {
        if (this.request) {
          this.workAreas = this.redirectionWorkAreas(serviceObject)
        } else {
          this.workAreas = []
        }
      },
      immediate: true
    }
  }
}
